<template>
  <div>
    <div class="col-4 submit btn-container">
      <button class="btn-cancel" @click="navigateToHome" :disabled="submitted"><span class="icon-cross" aria-label="close"></span></button>
      <button :class="{disabled: !formIsValid}" class="btn btn-primary" @click.stop="onSubmit()" :disabled="submitted" aria-label="done">Create</button>
    </div>
    <div>
      <label class="label" for="eventTitle">Event Title</label>
      <input id="eventTitle" v-model="title">
    </div>

    <hr>

    <div>
      <div>
        <label class="label" for="eventDescription">Event Description</label>
        <input id="eventDescription" v-model="description">
      </div>

      <div>
        <label class="label">Start Date</label>
        <datepicker id="startDate" v-model="startDate" name="uniquename" :disabledDates="disabledDates" @selected="validateStartDate"></datepicker>
      </div>

      <div>
        <label class="label">End Date</label>
        <datepicker id="endDate" v-model="endDate" name="uniquename" :disabledDates="disabledDates" aria-describedby="endDateFeedback" @selected="validateEndDate"></datepicker>
        <b-form-invalid-feedback id="endDateFeedback">
          End Date must be on or after Start Date
        </b-form-invalid-feedback>
      </div>

      <div>
        <label class="label">Start Time</label>
        <div>
          <input type="time" name="eventStartTimeInput" id="eventStartTimeInput" v-model="start_time" style="width:95%;"/>
        </div>
        <div>to</div>
        <label class="label">End Time</label>
        <div>
          <input type="time" name="eventEndTimeInput" id="eventEndTimeInput" v-model="end_time" style="width:95%;"/>
        </div>
      </div>

      <div>
        <label class="label" for="eventAddress">Address</label>
        <input id="eventAddress" v-model="address">
      </div>

      <div>
        <label class="label" for="eventOrganizerName">Organizer Name</label>
        <input id="eventOrganizerName" v-model="organizer_name">
      </div>

      <div>
        <label class="label" for="eventOrganizerEmail">Organizer Email</label>
        <input id="eventOrganizerEmail" v-model="organizer_email">
      </div>

      <div>
        <label class="label" for="eventOrganizerPhoneNumber">Organizer Phone</label>
        <input id="eventOrganizerPhoneNumber" v-model="organizer_phone_number">
      </div>
    </div>

    <hr>

    <div>
      <div>
        <label class="label" for="eventParentId">Folder</label>
        <select id="eventParentId" v-model="selectedFolder">
          <option v-for="learningSpace in learningSpaces" v-bind:value="learningSpace">
            {{ learningSpace.displayName }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import Datepicker from 'vuejs-datepicker'

  var DisableDate = function (startDate) {
    const date = (startDate) ? new Date(startDate) : new Date()
    return new Date(date.getFullYear(), date.getMonth(), date.getDate())
  }

  export default {
    name: 'edit-event',
    props: ['uuid'],
    components: {
      Datepicker
    },
    data: () => {
      return {
        submitted: false,
        selectedFolder: {},
        errors: [],
        userId: {},
        startDate: undefined,
        endDate: undefined,
        months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        disabledDates: {
          to: new DisableDate()
        },
        uuid: '',
        title: '',
        description: '',
        owningLibraryId: '',
        phone_number: '',
        address: '',
        start_date: '',
        end_date: '',
        start_time: '',
        end_time: '',
        organizer_name: '',
        organizer_email: '',
        organizer_phone_number: '',
        ownerName: ''
      }
    },
    mounted () {
      this.loadDataForEditEvent()
    },
    methods: {
      ...mapActions([
        'storeEvent',
        'loadLibrariesForUser'
      ]),
      eventDataIsValid () {
        let isValid = true
        if (!this.title) {
          isValid = false
          this.errors.push('Error: Event title cannot be blank or null')
        }
        if (!this.selectedFolder || !this.selectedFolder.uuid) {
          isValid = false
          this.errors.push('Error: Please select one folder in which to store this entity')
        }
        if (!this.allTimesAreValid()) {
          isValid = false
          this.errors.push('Error: Start Date and Time must be before End Date and Time')
        }
        return isValid
      },
      onSubmit () {
        if (!this.eventDataIsValid()) {
          this.$notify({
            group: 'notify',
            type: 'error',
            title: '',
            text: this.errors.join('\n')
          })
          this.errors = []
          return
        }
        this.submitted = true
        const eventData = {
          title: this.title,
          description: this.description,
          owningLibraryId: this.selectedFolder.uuid,
          phone_number: this.phone_number,
          address: this.address,
          start_date: this.changeDateToString(this.startDate),
          end_date: this.changeDateToString(this.endDate),
          start_time: this.start_time,
          end_time: this.end_time,
          organizer_name: this.organizer_name,
          organizer_email: this.organizer_email,
          organizer_phone_number: this.organizer_phone_number,
          ownerName: this.ownerName
        }
        this.storeEvent(eventData).then(response => {
          console.log('the response: ' + response)
          this.uuid = response.uuid
          this.$notify({
            group: 'notify',
            type: 'success',
            title: '',
            text: 'Event "' + this.title + '" created successfully.'
          })
          return this.$router.push({ name: 'eventDetail', params: { uuid: this.uuid } })
        })
      },
      setSelectedFolder () {
        let selectedFolder = {}
        let owningLibraryId = this.owningLibraryId
        this.learningSpaces.forEach(function (learningSpace) {
          if (owningLibraryId === learningSpace.uuid) {
            selectedFolder = learningSpace
          }
        })
        this.selectedFolder = selectedFolder
      },
      navigateToHome () {
        return this.$router.go(-1)
      },
      dateRangeIsValid (startDate, endDate) {
        let isValid = false
        if (startDate && endDate) {
          let start = new Date(startDate)
          let end = new Date(endDate)
          isValid = start.getDate() < end.getDate()
        }
        return isValid
      },
      allTimesAreValid () {
        let isValid = false
        let startDateTime = this.changeDateToString(this.startDate) + ' ' + this.start_time
        let endDateTime = this.changeDateToString(this.endDate) + ' ' + this.end_time
        if (startDateTime && endDateTime) {
          let start = new Date(startDateTime)
          let end = new Date(endDateTime)
          isValid = start.getTime() <= end.getTime()
        }
        return isValid
      },
      validatePickedDates (startDate, endDate) {
        console.log('inside validatePickedDates')
        if (!this.dateRangeIsValid(startDate, endDate)) {
          console.log('adding invalid classes')
          $('#endDateFeedback').show()
          $('#endDate').addClass('is-invalid')
        } else {
          console.log('adding valid classes')
          $('#endDateFeedback').hide()
          $('#endDate').addClass('is-valid')
        }
      },
      validateStartDate (startDate) {
        return this.validatePickedDates(startDate, this.endDate)
      },
      validateEndDate (endDate) {
        return this.validatePickedDates(this.startDate, endDate)
      },
      changeDateToString (selected) {
        if (selected) {
          const date = new Date(selected)
          let mm = String(this.months[date.getMonth()])
          let dd = date.getDate()
          if (dd < 10) {
            dd = '0' + dd
          }
          let yyyy = date.getFullYear()
          let formatted = mm + ' ' + dd + ' ' + yyyy
          return formatted
        }
        return undefined
      },
      loadDataForEditEvent () {
        this.userId = localStorage.getItem('userid')
        this.loadLibrariesForUser(this.userId)
      }
    },
    computed: {
      ...mapState({
        'learningSpaces': state => state.assessment.learningSpaces
      }),
      formIsValid: function () {
        return this.title && this.selectedFolder.uuid
      }
    }
  }
</script>

<style scoped>
  .label {
    font-size: 20px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/app/event/components/EventCreate.vue